import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-emrole",
  "use": "icon-emrole-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-emrole\"><path d=\"M833.18 166c-129.86-11.58-228-80.16-275.18-113.64A65.24 65.24 0 0 0 520 40a67.88 67.88 0 0 0-45.26 17.72C395.68 128.38 263.24 158.74 191.28 164.18 155.78 166.86 128 198.58 128 236.46V537.2C128 681.06 344.46 984 514.4 984 692.2 984 896 674.82 896 548.32V238c0.12-38-26.96-68.96-62.82-72z m-288.8 346.16V698a33.02 33.02 0 1 1-66 0v-186.28a112.12 112.12 0 1 1 66 0.44z\" fill=\"#2491FF\" p-id=\"2554\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol